import { useState, useEffect } from "react";
import { Steps, Button, Row, Col, Form, message } from "antd";
import API_KEY from "../../../api";
import ProductDetails from "./ProductDetails";
import FillDetails from "./FillDetails";
import UploadImages from "./UploadImages";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
const { Step } = Steps;

export default function StepsComponent() {
  const history = useHistory();
  const [product, setProduct] = useState(null);
  const [current, setCurrent] = useState(0);
  const [form] = Form.useForm();
  const params = useParams();

  const next = () => {
    if (current === 0) {
      console.log(
        form.validateFields(["secondary_category", "upload"]).then((value) => {
          setCurrent(current + 1);
        })
      );
    } else {
      setCurrent(current + 1);
    }
  };
  useEffect(() => {
    API_KEY.URL.get(API_KEY.path.products, {
      params: {
        "filter[id][_eq]": params?.id,
        fields: "*,product_images.*",
        // fields=*,product_images.*
      },
    })
      .then((res) => {
        if (res.data?.data.length > 0) {
          const product_data = res.data?.data[0];
          console.log(product_data, "product_data");
          setProduct(product_data);
          // map data to form fields
          form.setFieldsValue({
            secondary_category: product_data?.secondary_category,
            color_tag: product_data?.color_tag?product_data?.color_tag:undefined,
            product_id: product_data?.product_id,
            name: product_data?.name,
            description: product_data?.description,
            price: product_data?.price,
            currency: product_data?.currency,
            quantity: product_data?.quantity,
            sampling_lead_time: product_data?.sampling_lead_time,
            production_lead_time: product_data?.production_lead_time,
            moq: product_data?.moq,
            internal_price: product_data?.internal_price,
            internal_currency: product_data?.internal_currency,
            internal_quantity: product_data?.internal_quantity,
            vendor: product_data?.vendor,
            vendor_currency: product_data?.vendor_currency,
            vendor_price: product_data?.vendor_price,
            vendor_quantity: product_data?.vendor_quantity,
            material: product_data?.material
              ? product_data?.material
              : undefined,
            design: product_data?.design ? product_data?.design : undefined,
            technique: product_data?.technique
              ? product_data?.technique
              : undefined,
            dimensions: product_data?.dimensions
              ? product_data?.dimensions
              : undefined,
            tags: product_data?.tags ? product_data?.tags : undefined,
            shape: product_data?.shape ? product_data?.shape : undefined,
            // upload: product_data?.product_images,
          });
        } else {
          console.log("no data");
        }
      })
      .catch((error) => console.log(error));
  }, [form, params]);

  const prev = () => {
    setCurrent(current - 1);
  };
  const onFinish = (values) => {
    if (values) {
      console.log(values.shape);
      // const user_id = localStorage.getItem("userId");
      values.tags = values.tags?.join();
      values.material = values?.material?.join();
      values.shape = values.shape?.join();
      values.design = values?.design?.join();
      values.technique = values?.technique?.join();
      values.color_tag = values?.color_tag?.join();
      // values.user_id = JSON.parse(user_id);
      // values.status = "published";
      // values.id=parseInt(params?.id);
      delete values["upload"];
      API_KEY.URL.patch(`${API_KEY.path.products}/${params.id}`, values)
        .then((res) => {
          console.log(res.data, "products");
          if (res.status === 200) {
            message.success("Product edited and saved.");
            history.replace("/edit-product-success");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const steps = [
    {
      title: "Update product",
      content: <UploadImages />,
    },
    {
      title: "Update details",
      content: <ProductDetails />,
    },
    {
      title: "Update Product attributes",
      content: <FillDetails />,
    },
  ];

  return (
    <>
      <Form
        form={form}
        name="add-products"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row style={{ marginBottom: "3.625rem" }}>
          <Col span={12} offset={6}>
            <Steps direction="horizontal" current={current}>
              {steps.map((item) => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>
          </Col>
        </Row>
        <Row>
          <Col span={12} offset={6}>
            <div className="steps-content">
              <span hidden={current === 0 ? false : true}>
                <UploadImages
                  products_id={params?.id}
                  images={product?.product_images}
                  form={form}
                />
              </span>
              <span hidden={current === 1 ? false : true}>
                <ProductDetails form={form} />
              </span>
              <span hidden={current === 2 ? false : true}>
                <FillDetails form={form} />
              </span>
            </div>
          </Col>
        </Row>
        <Row className="steps-action" style={{ marginTop: "4rem" }}>
          <Col
            style={{ display: "flex", justifyContent: "space-between" }}
            span={12}
            offset={6}
          >
            {current > 0 && (
              <Col span={6}>
                <Button style={{ width: "100%" }} onClick={() => prev()}>
                  Previous
                </Button>
              </Col>
            )}

            {current === steps.length - 1 && (
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ width: "100%" }}
                  htmlType="submit"
                  onClick={() => onFinish()}
                >
                 Update
                </Button>
              </Col>
            )}

            {current < steps.length - 1 &&
              (current === 0 ? (
                <Col offset={18} span={6}>
                  <Button
                    style={{ width: "100%" }}
                    type="primary"
                    onClick={() => next()}
                  >
                    Next
                  </Button>
                </Col>
              ) : (
                <Col span={6}>
                  <Button
                    style={{ width: "100%" }}
                    type="primary"
                    onClick={() => next()}
                  >
                    Next
                  </Button>
                </Col>
              ))}
          </Col>
        </Row>
      </Form>
    </>
  );
}
